export {
  backgroundColor,
  borderColor,
  ringColor,
  textColor,
} from "./semantic";
export { systemColors } from "./system";
